import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Info from "./pages/info";
import Home from "./pages/home";
import HowPay from "./pages/howPay";
import Rules from "./pages/rules";
import HowGet from "./pages/howGet";
import FinalPage from "./pages/finalpage";
import SmsValidation from "./pages/smsvalidation";
import RegistrationStepOne from "./pages/registration/stepOne";
import RegistrationStepTwo from "./pages/registration/stepTwo";
import NotFoundPage from "./pages/notfoundpage";

export default function BasicExample(props) {
  //////////
  ////

  ////
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} income={props} />
        <Route path="/credit" component={HowGet} income={props} />
        <Route path="/rules" component={Rules} income={props} />
        <Route path="/faq" component={Info} income={props} />
        <Route path="/oplata" component={HowPay} income={props} />
        <Route path="/registration-step1-new2" component={RegistrationStepOne} income={props} />
        <Route
          path="/registration-step2-new2"
          component={RegistrationStepTwo}
          tel={props.location}
        />
        <Route path="/smsvalidation" component={SmsValidation} />
        <Route path="/final-1" component={FinalPage} />
        <Route path="/final-2" component={FinalPage} />
        <Route path="/final-3" component={FinalPage} />
        <Route path="/final-4" component={FinalPage} />
        <Route path="/final-5" component={FinalPage} />
        <Route path="/final-6" component={FinalPage} />
        <Route path="/final-7" component={FinalPage} />
        <Route path="/final-8" component={FinalPage} />
        <Route path="/final-9" component={FinalPage} />
        <Route exact path="/p2" component={Home} income={props} />
        <Route exact path="/p3" component={Home} income={props} />
        <Route exact path="/p4" component={Home} income={props} />
        <Route exact path="/p9" component={Home} income={props} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </Router>
  );
}



// WEBPACK FOOTER //
// src/Main.js